export default "__VITE_ASSET__fe3935a1__"